import { miniSerializeError } from '@reduxjs/toolkit';

const message = {
  type: 'REFRESH_TOKEN',
};

// @ts-ignore
export const baseQueryWithReauth = (baseQuery) => async (args, api, extraOptions) => {
  try {
    const result = await baseQuery(args, api, extraOptions);
    const status = result?.meta?.response?.status;
    if (status === 403 || status === 401) {
      window.postMessage(message, '*');

      const refreshToken = (event: WindowEventMap['message']) => {
        if (event.data && event.data.type === 'TOKEN') {
          api.dispatch({ type: 'workstation/setJwt', payload: event.data.payload });
          window.removeEventListener('message', refreshToken);
        }
      };
      window.addEventListener('message', refreshToken);
    }
    return result;
  } catch (error) {
    // @ts-ignore
    if (error) {
      return error;
    }

    return { error: miniSerializeError(error) };
  }
};
